import React, { type JSX, Suspense, lazy, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { Spinner } from '@mobi/component-library/Legacy/Spinner'
import { setShouldHideBackButton } from '@core/Areas/AppHeader/Store'
import { state$ as userAccountState$ } from '@core/State/UserAccount/userAccountDriver'
import { fullClientVersion } from '@core/Utils/clientVersion'
import { useObservableProperties } from '@core/Utils/hooks'

const App = lazy(() => import('@mobi/account/Areas/PersonalDetails/Components/App'))

export const PersonalDetailsPage = (): JSX.Element | null => {
  const dispatch = useDispatch()
  const { accountNumber } = useObservableProperties(userAccountState$, ['accountNumber'], {
    accountNumber: null,
  })

  const onOtpFlowActiveChange = useCallback(
    (isOtpFlowActive: boolean) => dispatch(setShouldHideBackButton(isOtpFlowActive)),
    [dispatch]
  )

  // This page cannot be loaded if the user isn't logged in anyway
  if (accountNumber === null) return <Spinner />

  return (
    <Suspense fallback={<Spinner />}>
      <App
        betAccountNumber={accountNumber}
        appVersion={fullClientVersion}
        onOtpFlowActiveChange={onOtpFlowActiveChange}
      />
    </Suspense>
  )
}
